// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__zBgDc","rightAdornment":"Header_rightAdornment__1NB96"};